<template>
  <div>
    <common-table ref="table" :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :buttons="buttons"
                  @returnId="returnId"
                  :permission="permission"/>
  <el-dialog :visible.sync="batchStatusDialogVisible" title="批量设置采集状态">
    <el-form :model="batchStatusForm" ref="batchStatusFormRef" label-width="120px">
      <el-form-item label="代理" prop="agentId">
        <el-select v-model="batchStatusForm.agentId" placeholder="请选择代理" filterable>
          <el-option v-for="item in selectIds" :key="item.id" :label="item.username" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="采集状态" prop="status">
        <el-select v-model.number="batchStatusForm.status" placeholder="请选择状态"> <!-- 修改：添加.number修饰符 -->
          <el-option label="开启" :value="1"></el-option> <!-- 修改：使用动态绑定数值 -->
          <el-option label="关闭" :value="0"></el-option> <!-- 修改：使用动态绑定数值 -->
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="batchStatusDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleBatchStatus">确定</el-button>
    </div>
  </el-dialog>
  </div>
</template>


<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: "DouYinUserInfo",
  components: {CommonTable},
  data() {
    return {
      batchStatusDialogVisible:false,
      batchStatusForm: {
        agentId: '',
        status: 1,
      },
      selectIds: [],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      },{
        name: 'userName',
        placeholder: '抖音昵称',
        type: 'input'
      },{
        name: 'status',
        placeholder: '采集状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '开启',
        }, {
          key: 0,
          value: '关闭',
        }]
      },],
      permission: {
        add: 'douYinUserInfo:add',
        update: 'douYinUserInfo:update',
        delete: 'douYinUserInfo:delete',
        deleteBatch: 'douYinUserInfo:deleteBatch'
      },
      url: {
        get: '/douYinUserInfo/listByCondition',
        add: '/douYinUserInfo/add',
        update: '/douYinUserInfo/update',
        delete: '/douYinUserInfo/delete/',
        delete_batch: '/douYinUserInfo/deleteBatch',
        status: '/douYinUserInfo/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'douYinId',
        label: '抖音ID',
        show: true,
        width: '',
      }, {
        field: 'userName',
        label: '抖音昵称',
        show: true,
        width: '',
      }, {
          field: 'secId',
          label: 'secId',
          show: true,
          width: '',
        },{
        field: 'status',
        label: '是否采集',
        show: true,
        status: true,
     /*   show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '采集失败',
            type: 'danger'
          }, {
            key: 1,
            value: '未采集',
            type: 'warning'
          }, {
            key: 3,
            value: '采集完成',
            type: 'success'
          }, {
            key: 2,
            value: '采集中',
            type: 'warning'
          }]
        },*/
        detail: false,
        width: '',
      },{
        field: 'goodStatus',
        label: '商品采集',
        show: true,
        status: true,
        detail: false,
        width: '',
      }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }],
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量修改采集状态',
        permission: 'douYinRelease:update',
        click: () => {
          console.log(this.selectIds,'33333333333')
          // if (this.selectIds.length <= 0) {
          //   this.$message.warning('请选中要修改的数据')
          //   return
          // }
          request.post({
            url: '/agent/getAll',
            success: (data) => {
              if (data.code == 0) {
                console.log(data,'222222')
                this.selectIds = data.data;
                console.log(this.selectIds)
                this.batchStatusDialogVisible = true
              }
            }
          });

        }
      }],
      formFields: {
        addTitle: '添加抖音用户信息',
        updateTitle: '更新抖音用户信息',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'userId',
          label: '用户',
          type: 'select',
          selectUrl: '/userInfo/getAllInfo',
          selectData: [],
          placeholder: '手机号',
          rules: [{message: '请输入手机号', trigger: 'blur', required: true}],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'douYinId',
          label: '抖音ID：',
          type: 'input',
          placeholder: '请输入抖音ID',
          rules:[{required: true, message: '请输入抖音ID', trigger: 'blur'}],
          add: true,
          update: true,
        }, {
          field: 'userName',
          label: '抖音昵称',
          type: 'input',
          placeholder: '请输入抖音昵称',
          rules: [{message: '请输入抖音昵称', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'secId',
          label: 'secId',
          type: 'input',
          placeholder: '请输入secId',
          rules: [{message: '请输入secId', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'status',
          label: '是否采集：',
          type: 'select',
          placeholder: '请选择状态',
          rules:[{required: true, message: '请选择状态', trigger: 'blur'}],
          selectData: [{
            id: 1,
            name: '采集'
          }, {
            id: 0,
            name: '不采集'
          }],
          // add: true,
          update: true,
          filterable: true,
        }],
      }
    }
  },   methods: {
    returnId(data) {
      this.selectIds = data;
      console.log('代理数据——————————'+this.selectIds)
    },  resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleBatchStatus() {
      console.log(this.batchStatusForm)
      this.$refs.batchStatusFormRef.validate((valid) => {
        if (valid) {
          // this.batchStatusForm.ids = this.selectIds.join(",")
          request.post({
            url: '/douYinUserInfo/batchStatus',
            data: this.batchStatusForm,
            confirm: '确定修改检测状态？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改检测状态成功");
                this.batchStatusDialogVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
